let isAppInHideableIframe = false;

/**
 * Teams integrations hide our iframe with inline style `visibility: hidden`, which causes
 * the browser engine to ignore all requests to requestAnimationFrame from within our iframe.
 * This is a problem for page load telemetry because it prevents our pages from ending and reporting
 * page loads while Teams is still hiding our iframe before coming out of cache. There are no
 * browser APIs tell us whether requestAnimationFrame will be called or not; we can infer via
 * window.document.visibilityState but not if a parent page has used CSS to hide our iframe.
 *
 * Setting this to `true` allows Teams apps to globally force all calls to requestAnimationFrameAfterStyleAndLayout
 * to report immediately instead of more correctly waiting for browser paint.
 */
export const setIsAppInHideableIframe = (isHidden: boolean) => {
  isAppInHideableIframe = isHidden;
};

// https://nolanlawson.com/2018/09/25/accurately-measuring-layout-on-the-web/
type RequestAnimationFrameAfterStyleAndLayout = (callback: (calledAfterStyleAndLayout: boolean) => void) => void;
export const requestAnimationFrameAfterStyleAndLayout: RequestAnimationFrameAfterStyleAndLayout = (callback) => {
  const isVisibilityStateHidden = window.document?.visibilityState !== 'visible';
  if (isVisibilityStateHidden || isAppInHideableIframe) {
    callback(false);
  } else {
    requestAnimationFrame(() => {
      setTimeout(() => {
        callback(true);
      });
    });
  }
};
